<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.uuid"
        placeholder="UUID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.username"
        placeholder="用户名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.transfer_object"
        placeholder="转移对象"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.type"
        placeholder="使用场景"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="兑换优惠码" value="exchange_coupon" />
        <el-option label="转让" value="transfer" />
        <el-option label="后台充值" value="backend_recharge" />
        <el-option label="兑换礼品卡" value="exchange_gift_card" />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="已完成" value="completed" />
        <el-option label="已撤回" value="revoked" />
      </el-select>
      <el-date-picker
        class="filter-item"
        v-model="listQuery.date"
        type="daterange"
        @change="changedata"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        range-separator="to"
        start-placeholder="Start date"
        end-placeholder="End date"
      >
      </el-date-picker>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <download-excel
        class="filter-item"
        :fields="json_fields"
        :fetch="handleExport"
        type="xls"
        name="GP操作记录表.xls"
        worksheet="GP操作记录表"
      >
        <el-button type="success" :loading="exportLoading">
          导出 Excel
        </el-button>
      </download-excel>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="UUID" width="120">
        <template slot-scope="scope">
          {{ scope.row.uuid }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户名称" width="140">
        <template slot-scope="scope">
          {{ scope.row.username || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="使用场景" min-width="110" align="center">
        <template slot-scope="scope">
          <!-- <el-tag v-if="scope.row.type === 'exchange_coupon'" type="warning">
            兑换优惠码
          </el-tag>
          <el-tag v-else-if="scope.row.type === 'transfer'" type="success">
            转让
          </el-tag>
          <el-tag
            v-else-if="scope.row.type === 'backend_recharge'"
            type="success"
          >
            后台充值
          </el-tag> -->
          {{ scope.row.remark || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="使用积分数量" min-width="110" align="center">
        <template slot-scope="scope">
          <span :style="{ color: scope.row.is_pay_out ? 'red' : 'green' }">
            {{ scope.row.is_pay_out ? '-' : '+' }}{{ scope.row.change || '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="转移对象" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.transfer_object || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="操作时间" min-width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.updated_at || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <!-- {{ scope.row.status_show || '-' }} -->
          <el-tag v-if="scope.row.status === 'completed'" type="success">
            已完成
          </el-tag>
          <el-tag v-else-if="scope.row.status === 'revoked'" type="info">
            已撤回
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        min-width="130"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope" v-if="scope.row.status === 'completed'">
          <el-button
            size="mini"
            type="warning"
            @click="returnRecord(scope.row)"
          >
            回退
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import downloadExcel from 'vue-json-excel'
export default {
  components: { downloadExcel },
  data() {
    return {
      list: null,
      total: null,
      listLoading: false,
      exportLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
      },
      json_fields: {
        UUID: {
          field: 'uuid',
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        用户名称: {
          field: 'username',
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        使用场景: {
          field: 'remark',
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        使用积分数量: {
          field: 'change',
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        转移对象: {
          field: 'transfer_uuid',
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        操作时间: {
          field: 'revoke_at',
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        状态: {
          field: 'status',
          callback: (value) => {
            if (value === 'completed') return '已完成'
            if (value === 'revoked') return '已撤回'
            return value || '-'
          },
        },
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    changedata(val) {
      console.log(val)
      if (val) {
        this.listQuery.start_at = val[0] + ' 00:00:00'
        this.listQuery.end_at = val[1] + ' 23:59:59'
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    handleExport() {
      if (!this.listQuery.start_at || !this.listQuery.end_at) {
        this.$message.warning('请选择开始与结束日期')
        return
      }
      this.exportLoading = true
      var listQuery = JSON.parse(JSON.stringify(this.listQuery))
      return request({
        url: '/api/backend/userAccount/logs',
        method: 'get',
        params: {
          ...listQuery,
          page: 1,
          limit: 100000,
        },
      })
        .then((response) => {
          console.log(response)
          return response.data.data
        })
        .finally((val) => {
          console.log(val)
          this.exportLoading = false
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/userAccount/logs',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    returnRecord(val) {
      this.$confirm('确定要回退该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/userAccount/revoke',
            method: 'post',
            data: {
              log_no: val.log_no,
            },
          }).then((response) => {
            this.$message({
              message: '回退成功',
              type: 'success',
            })
            this.getList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消回退',
          })
        })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
